import { useEffect, useState } from "react";
import axios from "axios";
import { Container, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faFacebookF,
  faTwitter,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";
import Header from "../Header/Header";
import Loading from "../Loading/Loading";
import CurrentCards from "../CurrentCards";
import FeaturedCards from "../FeaturedCards";
import { HEADING_BASE_URL } from "../../config";
import "./Body.css";

const Body = () => {
  const [headingData, setHeadingData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(HEADING_BASE_URL)
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data[0] : res.data;
        setHeadingData(data ?? {});
      })
      .catch(() => setHeadingData({}))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Loading />;

  const third = headingData?.third_header_text ?? "";
  const fifth = headingData?.fifth_header_text ?? "";

  return (
    <>
      <Header headingData={headingData} />
      <Container className="mt-5">
        <Row className="first-row">
          <div data-aos="fade-in" data-aos-duration="1000" data-aos-delay="200">
            <h3 className="text-center mt-5 mb-5">{third}</h3>
          </div>
          <CurrentCards />
        </Row>
        <Row>
          <FeaturedCards />
        </Row>
        <Row className="second-row mt-5 mb-5">
          <Col lg={12} md={12} sm={12} className="second-col">
            <div
              data-aos="fade-in"
              data-aos-duration="1000"
              data-aos-delay="200"
            >
              <h3>{fifth}</h3>
            </div>
            <div
              className="mail"
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="200"
            >
              <a href="mailto:hello@moneta.al" className="mail-btn">
                hello@moneta.al
              </a>
            </div>
            <div
              className="social-icons mt-5 mb-5"
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="200"
            >
              <a
                href="https://www.instagram.com/moneta_al/"
                target="_blank"
                rel="noreferrer noopener"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a
                href="https://www.facebook.com/appmoneta"
                target="_blank"
                rel="noreferrer noopener"
              >
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
              <a
                href="https://twitter.com/moneta_al"
                target="_blank"
                rel="noreferrer noopener"
              >
                <FontAwesomeIcon icon={faTwitter} />
              </a>
              <a
                href="https://www.linkedin.com/company/monetaapplication/about/?viewAsMember=true"
                target="_blank"
                rel="noreferrer noopener"
              >
                <FontAwesomeIcon icon={faLinkedinIn} />
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Body;
